import type { Agreement } from '@flow/libs/agreement/permission-types';

import { checkAcl } from '@flow/libs/utils/acl';

export const isBoxReorderAllowed = (agreement: Agreement) =>
  checkAcl(agreement.acl, 'agreement:box:reorder');
